import { TriggerHistoryElement } from './TriggerHistoryElement';

export class DefaultTriggerElement extends TriggerHistoryElement {
  constructor() {
    super();
  }
}
